export const CHANGE_STATE = 'COMPARE/CHANGE_STATE';
export const TOGGLE_ON_OFF = 'COMPARE/TOGGLE_ON_OFF';
export const CHANGE_VALUE = 'COMPARE/CHANGE_VALUE';
export const CHANGE_MODE = 'COMPARE/CHANGE_MODE';
